export const calculateTimeDifferenceInHours = (currentTime: Date, endTime: Date) => {
  const difference = endTime.getTime() - currentTime.getTime();
  return difference / 1000 / 60 / 60; // milliseconds to minutes
};

export const isTimeInPast = (currentTime: Date, endTime: Date) => {
  return endTime.getTime() < currentTime.getTime();
};
